import { Interceptor } from "@connectrpc/connect";

import {
  DataDogCustomActionOptions,
  DataDogSetGlobalContext,
} from "datadog-loader/loader";

export const logger: Interceptor = (next) => async (req) => {
  console.debug(`sending message to ${req.url} with message`, req.message);
  const res = await next(req);
  if (!res.stream) {
    console.debug("response:", res.message);
  }
  return res;
};

export const errorHandlerSetup: (
  ddSendCustomAction: ({ name, context }: DataDogCustomActionOptions) => void,
  ddSetGlobalContext: ({ name, context }: DataDogSetGlobalContext) => void
) => Interceptor = (ddSendCustomAction, ddSetGlobalContext) => {
  const errorHandlerInterceptor: Interceptor = (next) => async (req) => {
    try {
      // has to be split to trigger error
      const res = await next(req);
      return res;
    } catch (e) {
      ddSendCustomAction({
        name: "APIClientError",
        context: { url: req.url, error: e },
      });
      ddSetGlobalContext({
        name: "APIClientErrorContext",
        context: { url: req.url },
      });
      throw e;
    }
  };

  return errorHandlerInterceptor;
};
